import { DashboardBanner } from "../../../Component/Banner/Dashboardbanner"
import { ProgressTrack } from "../../../Component/LoadingBar/ProgressTrack"
import { ProgressTrackCard } from "../../../Component/LoadingBar/ProgressTrackCard"
import { StatusBadge } from "../../../Component/MiscComponent/PrimitiveComponent"
import { /* ByteFormatter,*/ daysLeft, DateFormatter, fIDR } from "../../../Service/Helper/Utils"
import { PaymentMethodPicker } from "./Child/PaymentMethodPicker"

// Dashboard Component
export const DashboardContent = ({ data, onNav }) => {
  const currPeriod = data?.currentPeriod ?? {}
  const fups = data?.fups ?? {}
  const serviceStatus = data?.serviceStatus ?? {}
  const fupStatus = serviceStatus?.fup ?? {}
  const fupEnabled = fupStatus?.visible === true
  // console.log(fupStatus)
  const showFupTopUp = fupStatus?.shouldShowTopUp === true

  const isPsb = currPeriod.type === "psb"

  const endDate = isPsb ? currPeriod.due_date : currPeriod.end_subscribe
  const startDate = isPsb ? currPeriod.start_date : currPeriod.start_subscribe
  const total = isPsb? currPeriod.grand_total : (currPeriod.grand_total==="0" ? currPeriod.final_price : currPeriod.grand_total)
  const isPaid = isPsb ? (currPeriod.paid === true || currPeriod.status === "paid") : currPeriod.paidStatus
  const dueDate = isPaid ? endDate : currPeriod.due
  const dayLeft = daysLeft(dueDate)

  const stats = [
    {
      icon:"fa fa-download",
      label:"Download",
      val:`${currPeriod.downlink ?? 0}`,
      unit: currPeriod.measurement ?? 'Mbps',
      color:"var(--accent)"
    },
    {
      icon:"fa fa-upload",
      label:"Upload",
      val:`${currPeriod.uplink ?? 0}`,
      unit: currPeriod.measurement ?? 'Mbps',
      color:"var(--success)"
    },
    {
      icon:"fa fa-money-bill",
      label:"Tagihan",
      val: fIDR(total ?? 0),
      unit:"",
      color:"var(--txt)"
    },
    {
      icon:"fa fa-clock",
      label:"Masa Aktif",
      val: !isPsb ? (dayLeft <= 0 ? (currPeriod?.customerStatus ?? 'habis') : `${dayLeft} hari`) : '-',
      unit: "",
      color: dayLeft <= 7? "var(--danger)" : "var(--warn)" },
  ]

  const instalatioNDetails = [
        [
          "Tanggal Instalasi",
          DateFormatter(currPeriod.start_date)
        ],
        [
          "Jatuh Tempo",
          DateFormatter(currPeriod.due_date)
        ],
        [
          "ODP",
          currPeriod.nearest_odp_id
        ],
        [
          `Tarikan`,
          `${currPeriod.fiber_pulling_range} m`
        ],
        [
          "PPPoE",
          currPeriod.pppoe_username
        ],
        [
          "Dibayar Via",
          currPeriod.paid_type
        ]
      ]

  const serviceBadge = {
    online: "badge-success",
    degraded: "badge-warn",
    limited: "badge-danger",
    unknown: "badge-surface"
  }[serviceStatus?.state] ?? "badge-surface"

  return (
    <div className="dashboard-home">

      {/* Banner */}
      <DashboardBanner
        fups = {fups}
        currPeriod = {currPeriod}
        fupEnabled = {fupEnabled}
        isPsb = {isPsb}
      />

      {/* Stats */}
      <div className="dashboard-stat-grid">
        {stats.map(({icon, label, val, unit, color}, i)=>(
          <div className="stat-chip" key={label} style={{ animationDelay:`${i*0.06}s` }}>
            <div style={{ fontSize:26, marginBottom:8 }}>
              <i className={icon}></i>
            </div>
            <div style={{ fontSize:11, color:"var(--txt3)", marginBottom:6, fontWeight:600, textTransform:"uppercase", letterSpacing:"0.05em" }}>{label}
            </div>
            <div style={{ fontSize:20, fontWeight:800, color }}>{val}
              <span style={{ fontSize:13, fontWeight:500, color:"var(--txt3)", marginLeft:3 }}>{unit}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Period + VA */}
      <div className="grid-7-5">
        <div className="card">
          <div className="card-header flex items-center gap-2" style={{ marginBottom:16 }}>
            <span style={{ fontSize:14, fontWeight:700 }}>{isPsb ? "Detail Pemasangan Baru" : "Periode Aktif"}</span>
            <span className={`badge ms-auto ${isPsb ? "badge-warn" : "badge-accent"}`}>{isPsb ? "Instalasi" : "Bulanan" }</span>
          </div>
          <div className="card-body">
            <div className="flex justify-between items-start" style={{ marginBottom:16 }}>
              <div>
                <div style={{ fontSize:16, fontWeight:700, marginBottom:3 }}>{currPeriod.itemName}</div>
                <div className="txt-muted">{currPeriod.mitraName || currPeriod.mitra_name}</div></div>
              <StatusBadge paid={isPaid} />
            </div>
            {isPsb ? (
              <div className="info-grid">
                {instalatioNDetails.map(([l,v])=>(
                  <div className="info-cell" key={l}><div className="info-label">{l}</div><div className="info-val">{v||"-"}</div></div>
                ))}
              </div>
            ) : (
              <>
                <ProgressTrack
                  min = {startDate}
                  max = {dueDate}
                  isDate = {true}
                  percentText = {"Terpakai"}
                  progressText = {"hari tersisa"}
                />
                <div className="row">
                  <div className="col-6 info-cell">
                    <div className="info-label">Tagihan</div>
                    <div className="info-val txt-accent">{fIDR(currPeriod?.price ?? 0)}</div>
                  </div>
                  <div className="col-6 info-cell">
                    <div className="info-label">{isPaid ? "Akhir Periode" : "Jatuh Tempo"}</div>
                    <div className="info-val">{DateFormatter(dueDate)}</div>
                  </div>
                  <div className="col-12 info-cell">
                    <div className="info-label">Dibayar Pada</div>
                    <div className="info-val">{DateFormatter(currPeriod?.paid ?? '')}</div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="card">
          {
            isPaid
            ? <></>
            : <PaymentMethodPicker
              data={data}
            />
          }
          <div className="card-body" style={{ display:"flex", flexDirection:"column", gap:8 }}>
            {/* <div className="rounded-row">
              <span className="txt-muted">Status Layanan</span>
              <span className={`badge ${serviceBadge}`}>{serviceStatus?.label ?? "Belum tersedia"}</span>
            </div> */}
            {/* {serviceStatus?.outage?.active && (
              <div className="alert alert-warning py-2" style={{ fontSize:12, marginBottom:0 }}>
                Terdapat gangguan jaringan di area layanan Anda.
              </div>
            )} */}
            {fupEnabled && (
              <>
              <ProgressTrackCard
                min = {fups?.monthlyTotal ?? 0}
                max = {fups?.quota ?? 0}
                isDate = {false}
                isGb = {true}
                isBanner = {true}
                percentText = {"Terpakai"}
                progressText = {"Quota Tersisa"}
              />
              </>
            )}
          </div>
          {showFupTopUp && (
            <button className="btn btn-outline-primary w-full" style={{ marginTop:8 }} onClick={()=>onNav("fup")}>
              <i className="fa fa-link me-1" />
              Beli Quota
            </button>
          )}
            <button className="btn-primary-custom w-full" style={{ marginTop:8 }} onClick={()=>onNav("billing")}>
              {
              !isPaid
                  ? 'Detail Tagihan Anda'
                  : 'Bukti Pembayaran Anda'
              }
            </button>
        </div>
      </div>
    </div>
  )
}
